const pageNameKey = "editSourceName";

export const editSourceNameEn = {
  [pageNameKey]: {
    save: "Save",
    edit: "Edit",
    cancel: "Cancel",
    errorInputEmpty: "Input cannot be empty",
    errorUpdateFailed:
      "It was not possible to modify the name, therefore we reverted the changes.",
    successfullyUpdated: "Machine name was successfully updated.",
  },
};

export const editSourceNamePtBr = {
  [pageNameKey]: {
    save: "Salvar",
    edit: "Editar",
    cancel: "Cancelar",
    errorInputEmpty: "A entrada não pode estar vazia",
    errorUpdateFailed:
      "Não foi possível modificar o nome, portanto revertimos as alterações.",
    successfullyUpdated: "O nome da máquina foi atualizado com sucesso.",
  },
};

export const editSourceNameDe = {
  [pageNameKey]: {
    save: "Speichern",
    edit: "Bearbeiten",
    cancel: "Abbrechen",
    errorInputEmpty: "Eingabe darf nicht leer sein",
    errorUpdateFailed:
      "Es war nicht möglich, den Namen zu ändern, daher haben wir die Änderungen rückgängig gemacht.",
    successfullyUpdated: "Maschinenname erfolgreich aktualisiert.",
  },
};

export const editSourceNameZhHans = {
  [pageNameKey]: {
    save: "保存",
    edit: "编辑",
    cancel: "取消",
    errorInputEmpty: "输入不能为空",
    errorUpdateFailed: "无法修改名称，因此我们已撤销更改。",
    successfullyUpdated: "机器名称已成功更新。",
  },
};

export const editSourceNameIt = {
  [pageNameKey]: {
    save: "Salva",
    edit: "Modifica",
    cancel: "Annulla",
    errorInputEmpty: "Il campo non può essere vuoto",
    errorUpdateFailed:
      "Non è stato possibile modificare il nome, quindi abbiamo ripristinato le modifiche.",
    successfullyUpdated: "Nome macchina aggiornato con successo.",
  },
};

export const editSourceNameEs = {
  [pageNameKey]: {
    save: "Guardar",
    edit: "Editar",
    cancel: "Cancelar",
    errorInputEmpty: "El campo no puede estar vacío",
    errorUpdateFailed:
      "No fue posible modificar el nombre, por lo tanto revertimos los cambios.",
    successfullyUpdated: "El nombre de la máquina se actualizó correctamente.",
  },
};

export const editSourceNameNl = {
  [pageNameKey]: {
    cancel: "Annuleren",
    edit: "Bewerken",
    errorInputEmpty: "Invoer mag niet leeg zijn",
    errorUpdateFailed:
      "Het was niet mogelijk om de naam te wijzigen, daarom hebben we de wijzigingen teruggedraaid.",
    save: "Opslaan",
    successfullyUpdated: "Machinenaam is succesvol bijgewerkt.",
  },
};

export const editSourceNameTr = {
  [pageNameKey]: {
    cancel: "İptal etmek",
    edit: "Düzenlemek",
    errorInputEmpty: "Giriş boş olamaz",
    errorUpdateFailed:
      "Adı değiştirmek mümkün olmadığından değişiklikleri geri aldık.",
    save: "Kaydetmek",
    successfullyUpdated: "Makine adı başarıyla güncellendi.",
  },
};
